// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Vi4T3","bigColWidth":"Table_bigColWidth__1PhML","biggerColWidth":"Table_biggerColWidth__1WtAE","row":"Table_row__2dhoV","col":"Table_col__7FVmS"};